import React from 'react';
import logo from "../../../Assets/Image/Thebook24.svg";

function LoadingWait({ isTrue }) {

    if (!isTrue) return null

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", position: "fixed", zIndex: 1020, top: 0, bottom: 0, right: 0, left: 0, background: "#00000080" }}>
                <div style={{ textAlign: "center" }} className="logo-loading"></div>
                <img src={logo} alt="logo" width={200} height={200} style={{ position: "absolute" }} loading='lazy' />
            </div>
        </>
    )
};

export { LoadingWait }